import { ClickEvent, DataSourceExecutionEvent, Toast } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import { CarrierOfferInfo, DispatchUtil, ModelMovement } from "@mcleod/dispatch";
import { CarrierAssignmentStepper } from "./CarrierAssignmentStepper";
import { AutogenLayoutCarrierOfferListDetail } from "./autogen/AutogenLayoutCarrierOfferListDetail";
import { Api, StringUtil } from "@mcleod/core";
import { CarrierOfferCounter, CounterOfferSummaryInfo } from "./CarrierOfferCounter";

export class CarrierOfferListDetail extends AutogenLayoutCarrierOfferListDetail {
    /** This is an event handler for the afterExecution event of sourceCarrierOfferList.  */
    sourceCarrierOfferListAfterExecution(event: DataSourceExecutionEvent) {
        this.checkNegativeValues();
        DispatchUtil.isAssignable(this.activeRow, { btnAssign: this.buttonAssignCarrier });
        const isCounterOffer = (this.activeRow.get("status") === "O" || this.activeRow.get("status") === "F") && !this.activeRow.isNull("counter_offer");
        this.buttonCounterOffer.visible = isCounterOffer;
        this.buttonDeclineOffer.visible = isCounterOffer;

        const brokerage = this.activeRow.getBoolean('movement.brokerage');
        const btmExclude = this.activeRow.getBoolean('movement.buy_to_market_ex');
        const showBtm = getDispatchControlBoolean('show_btm') && brokerage && !btmExclude;
        this.panelBuyToMarketTitles.visible = showBtm;
        this.panelBuyToMarketValues.visible = showBtm;
        this.panelCarrierRanking.visible = !this.activeRow.isNull("carrier_ranking");
    }

    /** This is an event handler for the onClick event of buttonAssignCarrier.  */
    buttonAssignCarrierOnClick(event: ClickEvent) {
        const carrierOfferInfo: CarrierOfferInfo = {
            payee_id: this.activeRow.get("payee_id", null),
            carrier_name: this.activeRow.get("carrier_name", ""),
            icc_number: this.activeRow.get("icc_number", null),
            dot_number: this.activeRow.get("dot_number", null),
            carrier_contact: this.activeRow.get("contact_name", ""),
            carrier_phone: this.activeRow.get("contact_phone", ""),
            carrier_email: this.activeRow.get("email", ""),
            dispatch_offer: this.activeRow.getCurrency("counter_offer", this.activeRow.getCurrency("amount")),
            carrier_empty_from_city_id: this.activeRow.get("tractor_city_id", "")
        }

        CarrierAssignmentStepper.showAsSlideout({
            movementId: this.activeRow.get("movement_id"),
            orderId: this.activeRow.get("order_id"),
            carrierAssignmentButton: this.buttonAssignCarrier,
            carrierOfferInfo,
            onClose: (canceled: boolean) => { if (!canceled) this.mainDataSource.search({ id: this.activeRow.get("id") }) },
        });
    }

    async buttonCounterOfferOnClick(event: ClickEvent) {
        const summaryInfo: CounterOfferSummaryInfo = {
            order_id: this.activeRow.get("order_id"),
            commodity: this.activeRow.get("orders.commodity"),
            distance: this.activeRow.get("movement.move_distance"),
            weight: this.activeRow.get("orders.weight"),
            equipment_type: this.activeRow.get("orders.equipment_type_id")
        }
        const moveRow = await new ModelMovement().searchSingle({ id: this.activeRow.get("movement_id") });
        CarrierOfferCounter.showCounterOfferSlideout({
            summaryInfo: summaryInfo,
            data: this.activeRow,
            doAfterSlideIn: (layout: CarrierOfferCounter) => {
                layout.setupCarrierInfo(this.activeRow.get("payee_id", null), this.activeRow.get("movement.is_carrier_scorecard_licensed", false));
                layout.layoutMovementCarrierPay.displayData(moveRow, null, 0);
                layout.layoutMovementCarrierPay.buttonOverrideTargetPay.visible = false;
                layout.layoutMovementCarrierPay.buttonOverrideMaxPay.visible = false;
            },
            onSave: (updatedData) => {
                this.mainDataSource.search({ id: this.activeRow.get("id") })
            }
        });
    }

    buttonDeclineOfferOnClick(event: ClickEvent) {
        Api.post("lme/powerbroker/decline-counter-offer", { offer_id: this.activeRow.get("id") }).then(() => {
            this.mainDataSource.search({ id: this.activeRow.get("id") });
            Toast.showSuccessToast("Offer declined successfully.");
        });
    }

    private checkNegativeValues() {
        this.labelMaxPercentage.color = this.labelMaxPercentage.getDataValue() < 0 ? "error" : "default";
        this.labelTargetPercentage.color = this.labelTargetPercentage.getDataValue() < 0 ? "error" : "default";
        this.labelDispatchPercentage.color = this.labelDispatchPercentage.getDataValue() < 0 ? "error" : "default";
        this.labelCounterPercentage.color = this.labelCounterPercentage.getDataValue() < 0 ? "error" : "default";
        if (!StringUtil.isEmptyString(this.activeRow.getString("buy_to_market"))) {
            const isOverMarket: boolean = this.activeRow.getString("buy_to_market").includes("OVER");
            this.labelBuyToMarketPercent.color = this.labelBuyToMarket.color = isOverMarket ? "error" : this.activeRow.isNull("buy_to_market") ? "default" : "success";
        }
    }
}

